import DOMPurify from 'dompurify';
var $ = require("jquery");
var editor = false;

function makeAceEditorResizable(editor) {
    // mouseup = css resize end
    document.addEventListener("mouseup", function (e) {
        editor.resize();
    });
}

function isTrue(setting) {
    return setting !== undefined && (setting === true || setting === "true")
}

function loadAceSettings() {

    editor.setTheme("ace/theme/" + userEditorTheme, function(){ loadThemeSettings() });
    editor.setAutoScrollEditorIntoView(false);

    editor.session.setUseWrapMode(userAceOptions.setUseWrapMode);
    editor.setOptions({
        enableSnippets: true,
        minLines: userAceOptions.minLines,
        enableBasicAutocompletion: userAceOptions.enableBasicAutocompletion,
        enableLiveAutocompletion: userAceOptions.enableLiveAutocompletion
    });

    editor.setShowPrintMargin(userAceOptions.setShowPrintMargin);
    editor.session.setUseSoftTabs(userAceOptions.setUseSoftTabs);
    editor.session.setUseWorker(userAceOptions.setUseWorker);
    editor.setHighlightActiveLine(userAceOptions.setHighlightActiveLine);

    editor.setOptions({
        fontFamily: userAceOptions.fontFamily,
        fontSize: userAceOptions.fontSize + "px",
    });

}

function loadAceEditor(form) {
    let form_id = form.attr("id")
    $("#editor_" + form_id).show();
    $("#ta_" + form_id).hide();

    const acepath = "/js/aceeditor/src-min-noconflict";

    ace.config.set('basePath', acepath);
    ace.config.set('modePath', acepath);
    ace.config.set('themePath', acepath);
    ace.config.set('workerPath', acepath);

    ace.require("ace/ext/language_tools");
    var beautify = ace.require("ace/ext/beautify");

    editor = ace.edit("editor_" + form_id);
    editor.session.setMode("ace/mode/php");

    editor.renderer.on('afterRender', function() {
        setTimeout(function(){
            if($("#editorloaded").length === 0) {
                $("#footer-content").prepend('<span id="editorloaded"></span>');
            }
            $("ins").removeAttr("aria-label");
            $("iframe").attr("title", 'frame');
            $(".ace_text-input").attr("aria-label", "Your PHP code");
    }, 100)});

    var host = window.location.host
    var subdomain = host.split('.')[0]

    var oldData = localStorage.getItem('editor_data');
    if (oldData && userSettings.userLoadLastCode !== false ) {
        if ($("#codeLoaded").val() !== "yes" && form_id === "sandboxform") {
            $("#ta_" + form_id).val(oldData);
        }
    }

    editor.getSession().setValue($("#ta_" + form_id).val());
    loadAceSettings()
    makeAceEditorResizable(editor);
    $(".beautify").click(function () {
        beautify.beautify(editor.session);
    });



}

function loadThemeSettings(){
    if(isTrue(userSettings.colorizeOutput)) {
        let bg = $("#editor_sandboxform").css("background-color");
        let color = $("#editor_sandboxform").css("color");
        let headercolor = $(".ace_gutter").css("background-color");
        $("#themestytle").remove();
        $("<style id='themestytle'>" +
            // "body{ --phpnav-bg:"+headercolor+" !important; --phpnav-color:"+color+" !important;} " +
            ".panel-right, .panel-right .autoheight, #output_sandboxform .autoheight{ " +
            "background-color: " + bg + "; color: " + color + ";} </style>").appendTo("head");
    }else{
        $("#themestytle").remove();
    }
}

function loadTextArea(form) {
    let form_id = form.attr("id")
    $("#ta_" + form_id).addClass('defaultTextarea').show();
    $("#editor_" + form_id).hide();
    $("#ta_" + form_id).each(function () {
        let height = Math.max(Math.min(this.scrollHeight, 450), 250);
        this.setAttribute("style", "height:" + height + "px;");
    });
}

function executeCode(form, func) {

    form.find("input[name=ajaxResult]").val('1');
    let data = form.serialize();
    let form_id = form.attr("id")
    outputLoadingSlide(form_id);

    form.find("button[type=submit]").attr('disabled', 'disabled');


    $("#346082079").remove();

    $.post("/" + func + "executeCode", data, function (d) {
        let html = sanitize(d)
        $("#output_share_save").html('');
        if (form_id === "sandboxform" && userSettings.leftRight === true) {
            $(".output_" + form_id).html(html);
            $("#output_" + form_id).html("");
        } else {
            $("#output_" + form_id).html(html);
            $(".output_" + form_id).html("");
        }
        autoHeightTextarea()
        form.find("button[type=submit]").removeAttr('disabled');

        // Google analytics
        window.dataLayer = window.dataLayer || [];

        function gtag() {
            dataLayer.push(arguments);
        }

        gtag('js', new Date());
        gtag('config', 'G-8P9R6GWMP3');
        gtag('config', 'UA-30655681-1');

        // Ads
        if (!userNoAds) {
            gloaded = gloaded + 1;

            if (gloaded > 3) {
                gloaded = 1;
                grefresh = true;
            }
            $(".google_inline_ad").html('<div id="onlinephp.io_1200x250_' + gloaded + '_ir"></div>')

            try {
                if (grefresh === false) {
                    googletag.cmd.push(function () {
                        googletag.display('onlinephp.io_1200x250_' + gloaded + '_ir');
                    });
                }else{
                    googletag.cmd.push(function () {
                        googletag.pubads().refresh([slots[gloaded]]);
                    });
                }

            } catch (error) {
                console.log("Error: " + error)
            }
        }
    });
}

function sanitize(html) {
    return DOMPurify.sanitize(html, {FORCE_BODY: true, WHOLE_DOCUMENT: true});
}

function outputLoadingSlide(id) {
    let html = "<div class='result'><div id=\"floatingCirclesG\">\n" +
        "\t<div class=\"f_circleG\" id=\"frotateG_01\"></div>\n" +
        "\t<div class=\"f_circleG\" id=\"frotateG_02\"></div>\n" +
        "\t<div class=\"f_circleG\" id=\"frotateG_03\"></div>\n" +
        "\t<div class=\"f_circleG\" id=\"frotateG_04\"></div>\n" +
        "\t<div class=\"f_circleG\" id=\"frotateG_05\"></div>\n" +
        "\t<div class=\"f_circleG\" id=\"frotateG_06\"></div>\n" +
        "\t<div class=\"f_circleG\" id=\"frotateG_07\"></div>\n" +
        "\t<div class=\"f_circleG\" id=\"frotateG_08\"></div>\n" +
        "</div></div>";
    if(userSettings.leftRight === true) {
        $(".output_" + id).html(html);
        $(".output_" + id).show();
    }else {
        $("#output_" + id).html(html);
        $("#output_" + id).slideDown();
    }

}

function setDataAndStorage(form_id) {
    if (userEditorTheme === 'textarea') {
        localStorage.setItem('editor_data', $("textarea[name=editor]").val());
    } else {
        let editor = ace.edit("editor_" + form_id);
        if (editor) {
            $("textarea[name=editor]").val(editor.getSession().getValue())
            if(form_id === "sandboxform") {
                localStorage.setItem('editor_data',
                    editor.getSession().getValue());
            }
        }
    }
}

function autoHeightTextarea() {
    $(".autoheight").each(function () {
        if(!$(this).hasClass("returnhtml")) {
            let currentHeight = $(this).height();
            let scrollHeight = this.scrollHeight;
            if (scrollHeight - 10 > currentHeight) {
                this.setAttribute("style", "height:" + (this.scrollHeight) + "px;");
            }
        }
    })
}

function aceOptions() {
    // Ace Options
    userAceOptions.setUseWrapMode = true
    userAceOptions.setShowPrintMargin = true
    userAceOptions.setHighlightActiveLine = true
    userAceOptions.setUseSoftTabs = false
    userAceOptions.minLines = 15
    userAceOptions.enableLiveAutocompletion = false
    userAceOptions.enableBasicAutocompletion = true
    userAceOptions.fontSize = "12"
    userAceOptions.fontFamily = ""
    userAceOptions.setUseWorker = true

    let ace_options = localStorage.getItem('ace_options');
    let options = userAceOptions;
    if(ace_options){
        options = JSON.parse(ace_options);;
    }
    if (options) {
        for (const [option, value] of Object.entries(userAceOptions)) {
            $(".ace-options-select[name='" + option + "']").val(value);
            $(".ace-options[name='" + option + "']").prop('checked', value);
        }
        for (const [option, value] of Object.entries(options)) {
            userAceOptions[option] = value;
            $(".ace-options-select[name='" + option + "']").val(value);
            $(".ace-options[name='" + option + "']").prop('checked', value);
        };
        loadAceSettings(editor);
    }

    $(".ace-options").change(function () {
        userAceOptions[$(this).prop("name")] = ($(this).prop("checked"));
        loadAceSettings(editor);
        localStorage.setItem('ace_options', JSON.stringify(userAceOptions));
    })
    $(".ace-options-select").change(function () {
        userAceOptions[$(this).prop("name")] = ($(this).val());
        loadAceSettings(editor);
        localStorage.setItem('ace_options', JSON.stringify(userAceOptions));
    })

}

$(document).ready(function () {
    // Set the ace options
    var editor_form = $('.php-editor-form');

    let theme = localStorage.getItem('editor_theme');
    if (theme) {
        userEditorTheme = theme
        $("#editor-style").val(theme)
    }

    // If we have a text editor, load the editor functions
    if (editor_form.length) {

        editor_form.each(function () {
            let editor_id = $(this).attr("id");

            // Load the editor
            if (userEditorTheme !== 'textarea') {
                loadAceEditor($(this))
                aceOptions()
            } else {
                loadTextArea($(this))
            }

            // Alt + Enter functionality for Ace
            document.getElementById('editor_' + editor_id).onkeyup = e => {
                if (userSettings.userUseAltEnter && (e.code === 'Enter' || e.code === 'NumpadEnter') && e.ctrlKey) document.querySelector('button[type="submit"]').click()
            }

            // Editor Style change
            let editorStyle = $('#editor-style');
            editorStyle.change(function () {

                let form = $(this).closest("form");
                let editor_id = form.attr("id")

                // var editor = ace.edit('editor_' + editor_id);

                let style = $(this).val();

                $.post("/ajax/saveEditor", {'editor': style});

                // Set the textarea data with the ace data
                $("#ta_" + editor_id).val(editor.getSession().getValue())

                if (style === "textarea") {
                    userEditorTheme = style
                    loadTextArea(form)

                } else {
                    userEditorTheme = style
                    loadAceEditor(form)
                    editor.setTheme("ace/theme/" + style, function(){ loadThemeSettings() });
                }
                localStorage.setItem('editor_theme', userEditorTheme);

                let loader = $("#loader");
                if (!loader.length) {
                    $("#footer").append("<iframe id=\"loader\" style=\"width:0; height:0; border:0;\"></iframe>");
                }
                $("#loader").attr("src", APP_URL + "/user/settheme?t=" + userEditorTheme)

            });
        })
    }

    // Set up the AJAX CSRF token
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    // Sandbox Submit
    $('#sandboxform').on("submit", function () {
        setDataAndStorage($(this).attr("id"));
        executeCode($(this), "");
        return false;
    });

    // Functions submit
    $('.functionform').on("submit", function () {
        $("input[name=ajax]").val('1');
        let func = $(this).find("input[name=function]").val();
        executeCode($(this), func + "/")
        return false;
    });

    // Examples submit
    $('.example-form').on("submit", function () {
        setDataAndStorage($(this).attr("id"));
        $(this).find("input[name=ajax]").val('1');

        executeCode($(this), "")
        return false;
    });

    // Block ctrl+s, redirect to save button
    document.addEventListener("keydown", function(e) {
        if ((e.ctrlKey || e.metaKey)  ) {
            if ((e.key !== undefined && e.key === "s") || (e.keyCode !== undefined && e.keyCode === 83)) {
                e.preventDefault();
                $(".saveCode").trigger("click");
            }
            if ((e.key !== undefined && e.key === "r") || (e.keyCode !== undefined && e.keyCode === 65)) {
                $(".saveCode").trigger("click");
            }
        }
    }, false);

    // Save code button
    $(".saveCode").click(function () {
        let form_id = $(this).closest("form").attr("id");
        setDataAndStorage(form_id);
        let data = $('#sandboxform').serialize();
        outputLoadingSlide('share_save');

        $.post("/ajax/savecode", data, function (d) {

            $("#output_share_save").html(d);

            autoHeightTextarea()
            if ($("#g-recaptcha").length) {
                grecaptcha.render("g-recaptcha", {
                    "sitekey": $("#g-recaptcha").attr("data-sitekey"),
                    "theme": $("#g-recaptcha").attr("data-theme")
                });
            }
            $("#passwordprotection").change(function(){
                if($(this).prop("checked")){
                    $("input[name='store']").prop("checked", true).prop("disabled", true);
                    $("#passwordprotect").slideDown();
                }else{
                    $("input[name='store']").prop("disabled", false);
                    $("#passwordprotect").slideUp();
                }
            });
        });
        return false;
    });

    // Save code button
    $(".editUserCode").click(function () {
        let form_id = $(this).closest("form").attr("id");
        setDataAndStorage(form_id);
        let data = $('#sandboxform').serialize();
        outputLoadingSlide('share_save');

        $.post("/ajax/editcode", data, function (d) {

            $("#output_share_save").html(d);

            autoHeightTextarea()
            if ($("#g-recaptcha").length) {
                grecaptcha.render("g-recaptcha", {
                    "sitekey": $("#g-recaptcha").attr("data-sitekey"),
                    "theme": $("#g-recaptcha").attr("data-theme")
                });
            }
            $("#passwordprotection").change(function(){
                if($(this).prop("checked")){
                    $("#passwordprotect").slideDown();
                }else{
                    $("#passwordprotect").slideUp();
                }
            });
        });
        return false;
    });

    $("#customamount").click(function () {
        $("#customamountradio").prop("checked", "checked");
    });

    $("input[name='amountBox']").click(function () {
        if ($(this).prop("checked")) {
            $("#amount").val($(this).val());
        }
    })

    $("#customamount").keyup(function () {
        $("#amount").val($(this).val());
    });

    $("body").on("click", ".showpassword", function(){
        let input = $("#password");
        if (input.attr("type") === "password") {
            input.attr("type", "text");
        } else {
            input.attr("type", "password");
        }
    })


    setInterval(function () {
        if (dontEnableThisVeryDangerous !== false) {
            $("body").prepend('<div id="saidNotToEnable" style="background:#FFF;color:#000;z-index:100000;width:100%;height: 100pc; padding: 100px;position: absolute; top: 0px; left: 0px;" ><h1>HEY YOU!!!</h1><span style="background-color: #FFF;color:#000">Woohoo, you found one of many easter eggs! <a href="/">close</a></span><br/><br/><iframe style="width:90%; height:700px" src="https://www.youtube.com/embed/dQw4w9WgXcQ?autoplay=1" title="Why did you do this!!?? Lol!" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>');
            $("#saidNotToEnable").show();
            dontEnableThisVeryDangerous = false;
        }
    }, 1000);

    $("body").on("click", "#saveShare", function () {
        setDataAndStorage('sandboxform')

        let data = $('#sandboxform').serialize();
        outputLoadingSlide('share_save');
        $.post("/ajax/saveshare", data, function (d) {

                $("#output_share_save").html(d);

            if ($("#g-recaptcha").length) {
                grecaptcha.render("g-recaptcha", {
                    "sitekey": $("#g-recaptcha").attr("data-sitekey"),
                    "theme": $("#g-recaptcha").attr("data-theme")
                });
            }
        });
        return false;
    });

    $("body").on("click", "#editShare", function () {
        setDataAndStorage('sandboxform')
        let data = $('#sandboxform').serialize();
        outputLoadingSlide('share_save');
        $.post("/ajax/editshare", data, function (d) {
            $("#output_share_save").html(d);
        });
        return false;
    });

    $(".alert-fade").delay(5000).fadeOut(3000);

    $("#logo").click(function () {
        document.location.href = APP_URL;
    })

    $("body").on("focus", ".click-copy", function () {
        $(this).select();
        document.execCommand('copy');
    })
    .on("click", "div.button", function () {
        window.location = $(this).find("a").attr("href");
        return false;
    });

    $("#sandboxform").on("click", ".toggle-result", function(){
        $(this).closest('.result').find('.results-textarea').toggle();
        $(this).closest('.result').find('.results-html').toggle();
    })
    .on("click", ".toggle-stats", function(){
        if($(this).hasClass("active")) {
            $(".functionresult .result-stats-table").hide();
            $(this).closest('.result').find('.result-h3').show();
            $(this).closest('.result').find('.results-textarea').show();
            $(this).closest('.result').find('.results-html').show();
            $(this).removeClass("active");
        }else{
            $(this).closest('.result').find('.result-h3').hide();
            $(this).closest('.result').find('.results-textarea').hide();
            $(this).closest('.result').find('.results-html').hide();
            $(".functionresult .result-stats-table").show();
            $(this).addClass("active");
        }
    });

    $(".load-saved-code").click(function () {
        outputLoadingSlide('sandboxform');
        $.get("/ajax/mysavedcode", function (d) {
            $("#output_share_save").html("");
            $("#output_sandboxform").html(d);
            $(".output_sandboxform").html(d);
        });
    });

    $("#local-file").change(function (input) {
        let file = this.files[0];
        let reader = new FileReader();
        reader.readAsText(file);

        reader.onload = function () {
            let fileContent = reader.result;
            $('#ta_sandboxform').val(fileContent);
            // let editor = ace.edit("editor_sandboxform");
            editor.getSession().setValue($("#ta_sandboxform").val());
            $("#local-file").val("")
        }
    });

    $(".php-versions-select").click(function () {

        if ($(".versiongroup :checked").length > 5) {
            alert("You can only select 5 versions at the same time at this moment")
            return false;
        }
    });

    $("input[name='colorizeOutput']").change(function(){
        let enabled = $(this).is(":checked");
        loadThemeSettings(enabled);
    });

    $(".options-reset").click(function(){
        if(confirm("Are you sure you want to reset all options?")){
            localStorage.clear();
            location.reload();
        }
    })

    $(".submit").click(function () {
        $('#sandboxform').submit();
    });

    $(".share-save").click(function () {
        $(".saveCode").click();
    });

    $(".clear-code").click(function () {
        if (confirm("Are you sure you want to clear all code in the editor?")) {
            $('#ta_sandboxform').val('<?php');
            // let editor = ace.edit("editor_sandboxform");
            editor.getSession().setValue($("#ta_sandboxform").val());
        }
    });

    $(".download-code").click(function () {
        setDataAndStorage("sandboxform");
        $(this).attr("download", "your_code.txt").attr("href", 'data:text/plain;base64,' + btoa(unescape(encodeURIComponent($("textarea[name=editor]").val())))).attr("target", "_blank");
    })

    $("._blank").attr("target", "_blank");
    autoHeightTextarea();

    if($(".countdown").length > 0){
        setInterval(function() {
            let count = $(".countdown").text();
            count = count -1;
            if(count > -1){
                $(".countdown").text(count)
            }
        }, 1000);
    }

    $('#accordion .accordionButton').click(function () {

        var content = $(this).closest('.content').find('.accordionContent');
        if (content.css('display') !== 'flex') {
            $(this).find('i').removeClass("fa-circle-plus").addClass("fa-circle-minus");
        } else {
            $(this).find('i').addClass("fa-circle-plus").removeClass("fa-circle-minus");
        }
        content.slideToggle({
            start: function () {
                $(this).css({
                    display: "flex"
                })
            }
        })
    });


    $(".multiselect").select2({
        placeholder: 'Select PHP Versions',
        closeOnSelect: false,
        maximumSelectionLength: 5,
        width: "90%",
    });

    $(".loginbutton").click(function(){
        window.location.href = $(this).attr("data-oauth");
    });


    $("#footer-content").prepend('<span id="domloaded"></span>');

});
